// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_invoice/get_purchase_invoice.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseInvoice } from "./common_pb.js";
import { InventoryLineItem } from "../inventory/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetPurchaseInvoiceRequest
 */
export class GetPurchaseInvoiceRequest extends Message<GetPurchaseInvoiceRequest> {
  /**
   * ID of the purchase invoice to retrieve
   *
   * @generated from field: string purchase_invoice_id = 1;
   */
  purchaseInvoiceId = "";

  /**
   * ID of the stock point to filter purchase invoices by stock point
   *
   * @generated from field: string stock_point_id = 2;
   */
  stockPointId = "";

  /**
   * ID of the supplier to filter purchase invoices by supplier
   *
   * @generated from field: string supplier_id = 3;
   */
  supplierId = "";

  constructor(data?: PartialMessage<GetPurchaseInvoiceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPurchaseInvoiceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPurchaseInvoiceRequest {
    return new GetPurchaseInvoiceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPurchaseInvoiceRequest {
    return new GetPurchaseInvoiceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPurchaseInvoiceRequest {
    return new GetPurchaseInvoiceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPurchaseInvoiceRequest | PlainMessage<GetPurchaseInvoiceRequest> | undefined, b: GetPurchaseInvoiceRequest | PlainMessage<GetPurchaseInvoiceRequest> | undefined): boolean {
    return proto3.util.equals(GetPurchaseInvoiceRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetPurchaseInvoiceResponse
 */
export class GetPurchaseInvoiceResponse extends Message<GetPurchaseInvoiceResponse> {
  /**
   * The purchase invoice details
   *
   * @generated from field: com.neulink.pharmacy.PurchaseInvoice purchase_invoice = 1;
   */
  purchaseInvoice?: PurchaseInvoice;

  /**
   * List of inventory items associated with the purchase invoice
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryLineItem inventory_items = 2;
   */
  inventoryItems: InventoryLineItem[] = [];

  /**
   * ID of the previous purchase invoice in the list, if available
   *
   * @generated from field: string previous_purchase_invoice_id = 3;
   */
  previousPurchaseInvoiceId = "";

  /**
   * ID of the next purchase invoice in the list, if available
   *
   * @generated from field: string next_purchase_invoice_id = 4;
   */
  nextPurchaseInvoiceId = "";

  /**
   * Total number of purchase invoices matching the criteria
   *
   * @generated from field: int32 total_count = 5;
   */
  totalCount = 0;

  /**
   * Current index of the purchase invoice in the list
   *
   * @generated from field: int32 current_index = 6;
   */
  currentIndex = 0;

  constructor(data?: PartialMessage<GetPurchaseInvoiceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPurchaseInvoiceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_invoice", kind: "message", T: PurchaseInvoice },
    { no: 2, name: "inventory_items", kind: "message", T: InventoryLineItem, repeated: true },
    { no: 3, name: "previous_purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "next_purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "current_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPurchaseInvoiceResponse {
    return new GetPurchaseInvoiceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPurchaseInvoiceResponse {
    return new GetPurchaseInvoiceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPurchaseInvoiceResponse {
    return new GetPurchaseInvoiceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPurchaseInvoiceResponse | PlainMessage<GetPurchaseInvoiceResponse> | undefined, b: GetPurchaseInvoiceResponse | PlainMessage<GetPurchaseInvoiceResponse> | undefined): boolean {
    return proto3.util.equals(GetPurchaseInvoiceResponse, a, b);
  }
}

